<template>
    <div>
        <div class="sub_tit">New Approvers</div>
        <table class="create_table">
            <colgroup>
                <col width="15%" />
                <col width="*" />
                <col width="15%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>Subsidiary
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <select
                            class="slt_white w100"
                            v-model="selectedSubsidiary"
                            @change="onSubsidiaryChange"
                        >
                            <option value>Select</option>
                            <option
                                v-for="item in availableSubsidiaryList"
                                :key="item.CODE_ID"
                                :value="item.CODE_ID"
                            >{{item.CODE_NAME}}</option>
                        </select>
                    </td>
                    <th>Country
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <select class="slt_white w100" v-model="selectedCountry">
                            <option value>Select</option>
                            <option
                                v-for="item in availableCountryList"
                                :key="item.CODE_ID"
                                :value="item.CODE_ID"
                            >{{item.CODE_NAME}}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>First Approver
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <label class="serach-wrap">
                            <input
                                type="text"
                                class="text_input"
                                placeholder="First Approver"
                                readonly
                                v-model="firstApproverId"
                            />
                            <a
                                href="javascript:"
                                class="in_btn_search"
                                @click="openSearchIdPopup('FIRST')"
                            >
                                <i class="ico_input_serach"></i>
                                <span class="sr_only">검색 열기</span>
                            </a>
                        </label>
                    </td>
                    <th>Second Approver
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <label class="serach-wrap">
                            <input
                                type="text"
                                class="text_input"
                                placeholder="Second Approver"
                                readonly
                                v-model="secondApproverId"
                            />
                            <a
                                href="javascript:"
                                class="in_btn_search"
                                @click="openSearchIdPopup('SECOND')"
                            >
                                <i class="ico_input_serach"></i>
                                <span class="sr_only">검색 열기</span>
                            </a>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- page btn -->
        <div class="btn_wrap_full topLine">
            <a href="javascript:" class="btn_white" @click="onBackToList()">List</a>
            <div class="btn_right">
                <a href="javascript:" class="btn_blue" @click="onCreateButtonClick">Create</a>
            </div>
        </div>
        <!-- //page btn -->
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil } from '@/utils';

import SearchIdPopup from './SearchIdPopup';

export default {
    name: '',
    components: {},
    props: {
        onBackToList: {
            type: Function,
            required: true,
        },
    },

    computed: {},

    data() {
        return {
            selectedSubsidiary: '',
            selectedCountry: '',

            availableCountryList: [],
            availableSubsidiaryList: [],

            firstApproverId: '',
            secondApproverId: '',
        };
    },

    created() {
        this.init();
    },

    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            await this.fetchInitData()
                .then(data => {
                    console.log('FetchInitData', data);
                    this.setSubsidiaryList(data.subsidiaryList);
                    this.setCountryList(data.countryList);
                })
                .catch(err => {
                    Vue.$log.error('Approval Mgmt Err: ', err);
                });

            SDLUtil.showLoadingBar(false);
        },
        fetchInitData() {
            const params = {};
            if (this.selectedSubsidiary) {
                params.subsidiary_cd = this.selectedSubsidiary;
            }
            return (
                axios
                    // Loads list of countries
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalMgmt.skp`, {
                        params,
                    })
                    .then(res => {
                        console.log('APPROVAL MGMT', res);
                        return res.data;
                    })
                    .catch(res => {
                        Vue.$log.error('Approval Mgmt: ', res);
                        if (res.data.error.code == 'HHP_FORBIDDEN') {
                            alert('You are not allowed');
                        }
                        return res.data.error;
                    })
            );
        },

        setSubsidiaryList(list) {
            if (typeof list === 'undefined' || list == null) return;
            list = list.map(item => {
                return {
                    CODE_ID: item.SUBSIDIARY_CD,
                    CODE_NAME: item.SUBSIDIARY_NM,
                };
            });
            this.availableSubsidiaryList = list;
        },

        onSubsidiaryChange() {
            this.selectedCountry = '';
            this.availableCountryList = [];
            this.firstApprover = '';
            this.secondApprover = '';
            this.init();
        },

        setCountryList(list) {
            if (typeof list === undefined || list == null) return;
            list = list.map(item => {
                return {
                    CODE_ID: item.CDCODE,
                    CODE_NAME: item.CDDESC,
                };
            });
            this.availableCountryList = list;
        },

        // init() {},
        openSearchIdPopup(target) {
            let onUserSelect = null;

            if (target === 'FIRST') {
                onUserSelect = userId => (this.firstApproverId = userId);
            } else {
                onUserSelect = userId => (this.secondApproverId = userId);
            }

            SDLUtil.show(
                SearchIdPopup,
                {
                    title: 'Search ID',
                    onUserSelect,
                },
                {
                    height: 'auto',
                },
            );
        },

        onCreateButtonClick() {
            if (!this.validateInput()) return;

            const data = this.createApprovers()
                .then(data => {
                    const title = 'Creation Succeeded!';
                    const msg = 'New approvers have been added!';
                    SDLUtil.alert({
                        title,
                        msg,
                        onOkEvt: () => {
                            const update = true;
                            this.onBackToList(update);
                        },
                    });
                })
                .catch(err => {
                    const title = 'Creation Failed!';
                    let msg = 'Failed to create a new record!';
                    if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                        msg = err.data.error.message;
                    }
                    SDLUtil.alert({
                        title,
                        msg,
                    });
                    return;
                });

            return;
        },

        validateInput() {
            if (this.selectedCountry == '') {
                const title = 'Invalid Input';
                const msg = 'Please select a country.';
                SDLUtil.alert({
                    title,
                    msg,
                });
                return false;
            }

            if (this.firstApproverId == '') {
                const title = 'Invalid Input';
                const msg = 'Please enter first approver.';
                SDLUtil.alert({
                    title,
                    msg,
                });
                return false;
            }

            if (this.secondApproverId == '') {
                const title = 'Invalid Input';
                const msg = 'Please enter second approver.';
                SDLUtil.alert({
                    title,
                    msg,
                });
                return false;
            }
            return true;
        },

        createApprovers() {
            const params = {
                country_cd: this.selectedCountry,
                f_approver_id: this.firstApproverId,
                s_approver_id: this.secondApproverId,
            };
            const path = '/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalModifyInsert.skp';

            return SDLUtil.postForm(path, params);
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/ApprovalManagementCreate.vue